var exports = {
  "kL": "xa15a2ab7--3ea399--container",
  "Zd": "xa15a2ab7--3ea399--form",
  "wx": "xa15a2ab7--3ea399--header",
  "DD": "xa15a2ab7--3ea399--title",
  "VA": "xa15a2ab7--3ea399--subtitle",
  "h_": "xa15a2ab7--3ea399--description",
  "Rb": "xa15a2ab7--3ea399--form-checkbox",
  "z3": "xa15a2ab7--3ea399--error",
};

module.exports = exports;
